// extracted by mini-css-extract-plugin
module.exports =  {"truncate-wrapper":"_wDx25R","truncateWrapper":"_wDx25R","toggle-control":"iBf28S7","toggleControl":"iBf28S7"};